import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=4edd4d4e&scoped=true"
import script from "./cascader.vue?vue&type=script&lang=js"
export * from "./cascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd4d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4edd4d4e')) {
      api.createRecord('4edd4d4e', component.options)
    } else {
      api.reload('4edd4d4e', component.options)
    }
    module.hot.accept("./cascader.vue?vue&type=template&id=4edd4d4e&scoped=true", function () {
      api.rerender('4edd4d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cascader.vue"
export default component.exports